import { convertDataListToSelectOptions } from './formConverters';

export const vacationTypeSelectOptions = [
  { id: 1, name: 'По заявлению' },
  { id: 2, name: 'Без сохранения заработной платы' },
  { id: 3, name: 'Учебный без сохранения заработной платы' },
  { id: 4, name: 'Учебный с сохранением заработной платы' },
  { id: 5, name: 'За вредные и (или) опасные условия труда' },
  // Закомментировано по требованиям заказчика
  { id: 6, name: 'Отпуск по беременности и родам' },
  { id: 7, name: 'По уходу за ребенком до 3-х лет' },
  { id: 8, name: 'По уходу за детьми-инвалидами' },
  { id: 9, name: 'В связи со сдачей крови и ее компонентов' }
];
export const vacationTypeOptions = convertDataListToSelectOptions(
  vacationTypeSelectOptions,
  {
    valueKey: 'id',
    labelKey: 'name'
  }
);

export const vacationReasonSelectOptions = [
  { id: 1, name: 'По семейным обстоятельствам' },
  { id: 2, name: 'Другое' }
];
export const vacationReasonOptions = convertDataListToSelectOptions(
  vacationReasonSelectOptions,
  {
    valueKey: 'id',
    labelKey: 'name'
  }
);

export const vacationChildKinshipDegreeSelectOptions = [
  { id: 1, name: 'Сын' },
  { id: 2, name: 'Дочь' }
];

export const vacationChildKinshipDegreeOptions = convertDataListToSelectOptions(
  vacationChildKinshipDegreeSelectOptions,
  {
    valueKey: 'id',
    labelKey: 'name'
  }
);
